<template>
  <li class="bg-white px-5 py-4 rounded-md shadow-md">
    <header class="flex items-center justify-between">
      <Link
        class="leading-tight font-semibold text-lg underline"
        v-if="url"
        :href="url"
        :text="name"
      />
      <strong v-else class="leading-tight font-semibold text-lg">
        {{ line.name }}
      </strong>
      <div class="ml-4">
        <Link
          v-if="abilities.delete"
          :href="route('cart.lines.destroy', [id])"
          preserve-scroll
          method="delete"
          class="w-8 h-8 flex text-gray-700 hover:text-gray-900"
          as="button"
        >
          <Icon type="trash" class="m-auto" size="5" />
        </Link>
      </div>
    </header>

    <Info
      v-if="info"
      :text="info.text"
      :date="info.date"
    />

    <Seat
      v-if="info"
      class="mt-4"
      :category="info.category"
      :theme="info.theme"
      :seat="info.seat"
    />

    <div v-if="options.length" class="mt-4">
      <Option
        label="Variante"
        :id="id"
        :options="options"
        :disabled="!abilities.updateOption"
      />
    </div>

    <div v-if="abilities.updateAmount" class="mt-4">
      <Amount
        label="Anzahl"
        :id="id"
        :amount="amount"
        :disabled="!abilities.updateAmount"
      />
    </div>

    <div class="mt-4 text-right text-lg">
      <strong>
        {{ formatPrice(total) }}
      </strong>
    </div>

    <template v-for="discount in discounts" :key="discount.id">
      <Coupon :line="id" v-bind="discount" />
    </template>
    <template v-if="abilities.applyCoupon">
      <div class="mt-4 mb-1">
        <ApplyCoupon
          class="w-full"
          :id="id"
          :theme="info?.theme"
        />
      </div>
    </template>

  </li>
</template>

<script setup>
import Icon from 'Web/Shared/Icon.vue';
import Link from 'Web/Shared/Link.vue';
import Info from '../Shared/Info.vue';
import Seat from '../Shared/Seat.vue';
import Amount from '../Shared/Amount.vue';
import Option from '../Shared/Option.vue';
import ApplyCoupon from '../Shared/ApplyCoupon.vue';
import Coupon from './Coupon.vue';
import { computed } from 'vue';
import rescue from '@/helpers/rescue';
import formatPrice from '@/helpers/formatPrice';

const props = defineProps({
  id: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  url: {
    type: String,
    required: false,
  },
  info: {
    type: String,
    required: false,
  },
  amount: {
    type: [Number, String],
    required: true,
  },
  total: {
    type: [Number, String],
    required: true,
  },
  options: {
    type: Array,
    default: () => [],
  },
  abilities: {
    type: Object,
    required: true,
  },
  linkable_type: {
    type: String,
    default: 'default',
  },
  discounts: {
    type: Array,
    default: () => [],
  },
});

const info = computed(() => rescue(() => JSON.parse(props.info), {
  text: info,
}));

</script>
